/** @jsx jsx */
import { jsx } from 'theme-ui'
import { number, string } from 'prop-types'

const Facebook = ({ color = 'silver', height = 32, ...props }) => {
  return (
    <svg
      width={32}
      height={height}
      viewBox="0 0 32 32"
      sx={{ fill: color }}
      {...props}
    >
      <g clipPath="url(#clip0)">
        <path
          d="M32 16c0-8.837-7.163-16-16-16C7.162 0 0 7.163 0 16c0 8.838 7.162 16 16 16 .094 0 .188 0 .281-.006v-12.45h-3.437v-4.006h3.437v-2.95c0-3.42 2.088-5.282 5.138-5.282 1.462 0 2.718.107 3.081.157v3.575h-2.1c-1.656 0-1.981.787-1.981 1.943v2.55h3.968l-.518 4.007h-3.45V31.38C27.106 29.463 32 23.306 32 16.001z"
          fill="#DBD6D1"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <path fill="#fff" d="M0 0H32V32H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}

Facebook.propTypes = {
  color: string,
  height: number,
}

export default Facebook
